<template>
  <nav
    class="ui left fixed vertical menu applicationList fuzzy-list"
    id="applicationList"
    :class="{ expanded: isExpanded }"
    @mouseenter="mouseIn = true"
    @mouseleave="mouseIn = false"
  >
    <Spinny :promise="appsPromise" />
    <Placy
      v-if="!apps.length"
      :promise="appsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('APPLICATION', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('APPLICATION', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="apps.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          @focus="searchFocused = true"
          @blur="searchFocused = false"
          @keydown.esc="searchTerm = ''"
          autocomplete="off"
        />
        <i class="search icon"></i>
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-app' }">
      <i class="plus icon"></i>
      <strong>{{ $t('NEW', { thing: $tc('APPLICATION', 1) }) }}</strong>
    </router-link>
    <single-application
      :key="app.original.id"
      v-for="app in filteredItems"
      :app="app.original"
      :appType="appTypes && appTypes[app.original.type]"
      :appGroupColors="app.original.groupsColors"
      :nameWithHighlights="app.string"
      :active="$route.params.appId && $route.params.appId === app.original.id"
    />
  </nav>
</template>

<style lang="scss">
// Not scoped because we use v-html
@charset "utf-8";
@import '../../scss/variables';
#applicationList {
  overflow-y: scroll;

  -webkit-transition: all 0.3s, -webkit-transform 0.5s;
  transition: all 0.5s, transform 0.5s;
  transition-delay: 100ms;

  -webkit-transform: translate3d(calc(-100% + 10px), 0, 0);
  transform: translate3d(calc(-100% + 10px), 0, 0);

  &.expanded {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  width: 16rem;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Spinny, Placy } from 'ui'
import { Manufacturer, Application, Toast, Group, Typenames } from 'services'
import SingleApplication from './SingleApplication'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'app-list',
  components: { Spinny, Placy, SingleApplication },
  mixins: [FuzzyFilterer],

  data() {
    return {
      appTypes: [],
      mouseIn: false,
      searchFocused: false,
      appsPromise: null
    }
  },

  computed: {
    apps() {
      return this.$store.state.application.items
    },
    groups() {
      return this.$store.state.group.items
    },
    manufacturers() {
      return this.$store.state.manufacturer.items
    },
    isExpanded() {
      return this.$route.name === 'applications' || this.mouseIn || this.searchFocused
    },
    appsWithManufacturer() {
      return _.map(this.apps, a => {
        return {
          ...a,
          manufacturerObject: _.find(this.manufacturers, { id: a.manufacturer || '' })
        }
      })
    },
    // The collection to be filtered: apps with colors
    items() {
      return this.appsWithManufacturer.map(app => {
        app.groupsColors = []
        this.groups.forEach(group => {
          if (_.includes(group.application, app.id) && group.color !== Group.defaultColor) {
            app.groupsColors.push(group.color)
          }
        })
        return app
      })
    }
  },

  mounted() {
    Application.getAllApplicationTypes().then(types => (this.appTypes = _.keyBy(types, 'type')))
  },
  created() {
    this.appsPromise = Promise.all([
      Application.readAllApps(),
      Group.readAllGroups(),
      Manufacturer.readAllManufacturers()
    ])
  }
}
</script>
